import { groq } from "next-sanity";
import { getClient } from "../sanity";

export type SqlCategory = {
  slug: string;
  name: string;
};

export type SqlPageSimple = {
  slug: string;
  name: string;
  order: number;
  categoryName: string;
};

export type SqlPage = {
  createdAt: string;
  updatedAt: string;
  slug: string;
  name: string;
  order: number;
  category: SqlCategory;
  content: string;
  related: SqlPageSimple[];
  metaTitle?: string;
  metaDescription?: string;
};

export const getSqlPage = async (slug: string): Promise<SqlPage> => {
  const query = groq`
    *[_type == "sqlPage" && slug == "${slug}"] {
      'createdAt': _createdAt,
      'updatedAt': _updatedAt,
      slug,
      name,
      order,
      content,
      metaTitle,
      metaDescription,
      category->{ slug, name },
      related[]->{ slug, name, order, 'categoryName': category->name },
    }
  `;

  const sqlPage = await getClient().fetch(query);
  return sqlPage[0];
};

export const getSqlPages = async (): Promise<SqlPageSimple[]> => {
  const query = groq`
    *[_type == "sqlPage"] {
      slug,
      name,
      order,
      'categoryName': category->name
    } | order(order)
  `;

  const sqlPages = await getClient().fetch(query);
  return sqlPages;
};
